<template>
  <el-select
    :value="selectValue"
    :disabled="disabled"
    :size="size"
    :clearable="clearable"
    filterable
    remote
    reserve-keyword
    :loading="loading"
    :placeholder="placeholder"
    popper-class="ai-organization-select-dropdown"
    style="width: 100%"
    @input="handleInput"
    @change="handleChange"
    @visible-change="handleVisibleChange"
    :remote-method="remoteSearch"
  >
    <el-option
      v-for="item in options"
      :key="normalizeId(item.id)"
      :label="formatLabel(item)"
      :value="normalizeId(item.id)"
    >
      <div class="organization-option">
        <div class="organization-option__main">
          <span class="organization-option__name">{{ item.name || '未命名组织' }}</span>
          <span class="organization-option__id">ID: {{ item.id }}</span>
        </div>
        <div class="organization-option__sub">
          <span>所有者: {{ item.ownerAccountId || '-' }}</span>
          <span>{{ item.status === 0 ? '停用' : '启用' }}</span>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { getOrganizations } from '@/api/ai/rights'

export default {
  name: 'AiOrganizationSelector',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: '搜索组织ID/名称'
    },
    size: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      loading: false,
      options: [],
      searchTimer: null,
      requestSeq: 0
    }
  },
  computed: {
    selectValue () {
      return this.normalizeId(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.loadSelected(val)
      }
    }
  },
  beforeDestroy () {
    if (this.searchTimer) clearTimeout(this.searchTimer)
  },
  methods: {
    normalizeId (value) {
      if (value === undefined || value === null) return ''
      return String(value)
    },
    formatLabel (item) {
      if (!item) return ''
      return `${item.name || '未命名组织'} / ID:${item.id}`
    },
    normalizeRecords (res) {
      return (res && res.records) || []
    },
    mergeOptions (records) {
      const map = {}
      const merged = []
      const source = [...this.options, ...records]
      source.forEach(item => {
        const id = this.normalizeId(item && item.id)
        if (!id || map[id]) return
        map[id] = true
        merged.push(item)
      })
      this.options = merged
    },
    loadSelected (value) {
      const id = this.normalizeId(value)
      if (!id || this.options.some(item => this.normalizeId(item.id) === id)) return
      getOrganizations({
        currentPage: 1,
        pageSize: 20,
        keyword: id
      }).then(res => {
        this.mergeOptions(this.normalizeRecords(res))
      })
    },
    loadOptions (keyword) {
      const seq = ++this.requestSeq
      this.loading = true
      getOrganizations({
        currentPage: 1,
        pageSize: this.pageSize,
        keyword: keyword || ''
      }).then(res => {
        if (seq !== this.requestSeq) return
        this.options = this.normalizeRecords(res)
        this.loadSelected(this.value)
      }).finally(() => {
        if (seq === this.requestSeq) this.loading = false
      })
    },
    remoteSearch (keyword) {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.loadOptions(keyword)
      }, 250)
    },
    handleVisibleChange (visible) {
      if (visible && this.options.length === 0) {
        this.loadOptions('')
      }
    },
    handleInput (value) {
      this.$emit('input', value || '')
    },
    handleChange (value) {
      const id = this.normalizeId(value)
      const selected = this.options.find(item => this.normalizeId(item.id) === id) || null
      this.$emit('change', selected)
    }
  }
}
</script>

<style>
.ai-organization-select-dropdown .el-select-dropdown__item {
  height: 58px;
  line-height: normal;
  padding: 6px 20px;
}

.ai-organization-select-dropdown .el-select-dropdown__item.selected {
  font-weight: normal;
}
</style>

<style scoped>
.organization-option {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px 0;
  line-height: 18px;
}

.organization-option__main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.organization-option__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.organization-option__id,
.organization-option__sub {
  color: #909399;
  font-size: 12px;
}

.organization-option__sub {
  display: flex;
  gap: 12px;
}
</style>
